import consumer from './cable';

// One subscription per exports table rendered on the page: each refreshes only the rows of its own category.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-export-table]').forEach((table) => {
    const category = table.dataset.exportTable;
    const rows = table.querySelector('[data-export-rows]');
    const template = rows.querySelector('[data-export-template]');
    const triggerSelector = `[data-export-trigger="${category}"]`;
    const historySize = Number(table.dataset.exportHistorySize);
    let scrollRequested = false;

    const generatingRows = () => rows.querySelectorAll('[data-export-generating]');

    const refreshSeparators = () => {
      const rendered = rows.querySelectorAll('[data-export-row]');

      rendered.forEach((row, index) => {
        row.classList.toggle('border-bottom', index < rendered.length - 1);
      });
    };

    const refreshTrigger = () => {
      const disabled = generatingRows().length > 0;

      document.querySelectorAll(triggerSelector).forEach((trigger) => {
        trigger.disabled = disabled;
      });
    };

    const scrollToTable = () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const target = table.closest('[data-export-container]') || table;

      target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    };

    document.addEventListener('submit', (event) => {
      const trigger = event.target.querySelector?.(triggerSelector);

      if (!trigger) return;

      trigger.disabled = true;
      scrollRequested = true;
    }, true);

    // A row already on the page is refreshed in place, so a reload during the generation stays consistent.
    const rowFor = (exportId) => {
      const existing = rows.querySelector(`[data-export-row="${exportId}"]`);

      if (existing) {
        return existing;
      }

      const row = template.cloneNode(true);
      row.removeAttribute('data-export-template');
      row.dataset.exportRow = exportId;
      row.classList.remove('d-none');
      rows.prepend(row);

      rows.querySelectorAll('[data-export-row]').forEach((rendered, index) => {
        if (index >= historySize) {
          rendered.remove();
        }
      });

      refreshSeparators();

      return row;
    };

    consumer.subscriptions.create(
      {
        channel: 'Distributors::ExportsChannel',
        profile_id: table.dataset.profileId,
        // The channel replays this history on every connection, so a reconnection re-syncs the rows.
        category,
        history_size: historySize,
      },
      {
        received(data) {
          if (data.category !== category) {
            return;
          }

          table.classList.remove('d-none');
          table.closest('[data-export-container]')?.classList.remove('d-none');

          const row = rowFor(data.export_id);
          const badge = row.querySelector('[data-export-badge]');
          const download = row.querySelector('[data-export-download]');

          row.toggleAttribute('data-export-generating', data.generating);
          row.querySelector('[data-export-date]').textContent = data.performed_at;
          badge.className = data.badge_class;
          badge.textContent = data.status_text;

          row.querySelector('[data-export-spinner]').classList.toggle('d-none', !data.generating);
          download.classList.toggle('d-none', !data.download_url);

          if (data.download_url) {
            download.href = data.download_url;
          }

          refreshTrigger();

          if (scrollRequested) {
            scrollRequested = false;
            scrollToTable();
          }
        },
      },
    );
  });
});
